import { useMemo } from 'react';

import { PersonOutline } from '@lyearn/icons';
import { UseFilterValuesParams } from '@/components/FilterNew/types';
import useJourneyData from '@/modules/journey/views/JourneyReport/hooks/useJourneyData';

export const USER_ME_FILTER = { property: 'ly__userId_me', label: 'Me' };

export const ME_OPTION = {
  value: USER_ME_FILTER.property,
  label: USER_ME_FILTER.label,
  name: USER_ME_FILTER.label,
  Icon: PersonOutline,
};

const useBatchFilterValue = ({ value, tagValuesStore, queryParams }: UseFilterValuesParams) => {
  const { journeyId } = queryParams;
  const { journey, fetching, error } = useJourneyData({ journeyId });
  const valueSet = useMemo(() => {
    return new Set(value);
  }, [value, value.length]);

  const batchConfigs =
    useMemo(() => {
      return journey?.participantConfigs?.batchConfigs
        ?.filter(
          (batchConfig) => valueSet.has(batchConfig.groupId) && !!batchConfig?.canManageBatch,
        )
        .map((config) => ({ value: config.groupId, label: config.name }));
    }, [journey, valueSet]) ?? [];

  const labels = (batchConfigs.map((config) => config.label) as string[]) ?? [];

  return {
    fetching: fetching,
    resolvedValue: (labels ?? []) as any,
    selectedOptions: batchConfigs as any,
  };
};

export default useBatchFilterValue;
